import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../services/user.service";
import { AuthModel, AppTokenClientService } from "@nousmedis/nm-guard-auth";
import { User } from "@nousmedis/guard-types/frontend";
import { Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "environment";

@Component({
  selector: "app-auth",
  templateUrl: "./auth.component.html",
  styleUrls: ["./auth.component.scss"],
})
export class AuthComponent implements OnInit {
  paramsLoaded: Subject<boolean> = new Subject<boolean>();
  auth: any;
  user: User;
  error: string[] = [];
  token: any;
  accessDenied = false;

  constructor (
    private route: ActivatedRoute,
    private userService: UserService,
    private routing: Router,
    private authModel: AuthModel,
    private appTokenClientService: AppTokenClientService,
    private http: HttpClient
  ) {}

  checkToken(tokenId: string, userid: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.appTokenClientService.getById(tokenId, userid).then((res) => {
        resolve(res);
      }).catch((err) => {
        this.error.push("Error getting token: " + err);
        reject(err);
      });
    });
  }

  ngOnInit(): void {
    let tokenId = this.route.snapshot.paramMap.get("id");
    let userId = this.route.snapshot.paramMap.get("userId");
    
    this.authModel.resetUserCookie();
    sessionStorage.removeItem('current_instance');
    sessionStorage.removeItem('current_org');

    if (tokenId) {
      this.checkToken(tokenId, userId).then(async (res) => {
        let decodedToken = this.authModel.decodeToken(res.token);
        console.log("Decoded token: ", decodedToken);
        if (decodedToken.user && decodedToken.user.apiServer) {
          sessionStorage.setItem("api_server", decodedToken.user.apiServer);
          this.userService.user$.next(decodedToken.user.user);
        } else {
          this.error.push("Invalid token: missing user or apiServer");
          return;
        }
        if (decodedToken.user.org && decodedToken.user.user.id) {
          this.authModel.setCurrentOrgCookie(decodedToken.user.org, decodedToken.user.user.id);
          this.userService.setCurrentOrg(decodedToken.user.org);
          sessionStorage.setItem('current_org', JSON.stringify(decodedToken.user.org));
        }
        if (res.token) {
          this.authModel.setTokenCookie(res.token);
        }
        if (res.refreshToken) {
          localStorage.setItem("refresh_token", res.refreshToken);
        }

        let userOrgs = await this.authModel.getAllOrgsOfUser(decodedToken.user.user.id);
        this.userService.setOrgs(userOrgs);
        if (userOrgs) {
          sessionStorage.setItem("user_orgs", JSON.stringify(userOrgs));
        }

        try {
          const ccUrl = environment.auth_server + 'organitzation/user/' + decodedToken.user.user.id + '/catalog-clouds';
          const headers = new HttpHeaders({ Authorization: 'Bearer ' + res.token });
          const { firstValueFrom } = await import("rxjs");
          const ccInstances = await firstValueFrom(this.http.get<any[]>(ccUrl, { headers }));
          if (ccInstances) {
            sessionStorage.setItem("cc_instances", JSON.stringify(ccInstances));
            // Buscar el nombre de la instancia actual comparando origin de la URL
            const apiServer = decodedToken.user.apiServer?.toLowerCase().replace(/\/$/, '');
            for (const org of ccInstances as Array<{ organizacion: string; servicios: Array<{ servicio: string; url: string; apiServer?: string }> }>) {
              const match = org.servicios?.find(srv =>
                srv.apiServer?.toLowerCase().replace(/\/$/, '') === apiServer
              );
              if (match) {
                sessionStorage.setItem('current_instance', match.servicio);
                break;
              }
            }
          }
        } catch (e) {
          // No bloquear el flujo si falla
        }

        const roleCode = decodedToken.role?.code;
        if (roleCode === 'super_admin') {
          setTimeout(() => window.location.href = "/dash", 2000);
          return;
        }

        try {
          const ccUserUrl = decodedToken.user.apiServer + '/api/v1/users/' + decodedToken.user.user.id;
          const ccUserHeaders = new HttpHeaders({ 'api-key': 'Bearer ' + res.token });
          const { firstValueFrom } = await import("rxjs");
          await firstValueFrom(this.http.get<any>(ccUserUrl, { headers: ccUserHeaders }));
          setTimeout(() => window.location.href = "/dash", 2000);
        } catch (e: any) {
          this.clearSession();
          this.accessDenied = true;
        }
      });
    }
  }

  clearSession(): void {
    this.authModel.resetUserCookie();
    sessionStorage.removeItem('api_server');
    sessionStorage.removeItem('user_orgs');
    sessionStorage.removeItem('cc_instances');
    sessionStorage.removeItem('current_org');
    sessionStorage.removeItem('current_instance');
    localStorage.removeItem('refresh_token');
  }

  goToLogin(): void {
    this.clearSession();
    this.routing.navigate(['/login']);
  }
}
